import root from '../utils/root';

/**
 * @returns {Object} VWO Campaing data
 */
export function getCampaigns() {
  return root._vwo_campaignData || {};// eslint-disable-line
}

/**
 * @returns {Array} VWO Experiment IDs array
 */
export function getExperiments() {
  return Object.keys(getCampaigns());
}

/**
 * @returns {String} VWO Experiment IDs joined by a pipe (|)
 */
export function getExperimentIdsAsString() {
  return getExperiments().join('|');
}

/**
 * @returns {Array} VWO Variation IDs joined by a pipe (|)
 */
export function getVariantionIdsAsString() {
  const campaigns = getCampaigns();
  return getExperiments().map(key => campaigns[key].n).join('|');
}
